module.exports = __webpack_public_path__ + "img/thumbnail_Markhor_j_leucistic.e36f3519.png";